import * as React from "react";
import { NavigationItem } from "@atlassiansox/microscopekit";
import lightstepIcon from "./lightstep-icon.svg";
const SVG = require("react-inlinesvg").default;
const Icon = require("@atlaskit/icon").default;
export class LightstepNavigationLinks extends React.Component<{ id: string }> {
  render() {
    return (
      <NavigationItem
        icon={
          <Icon label="LightStep" glyph={() => <SVG src={lightstepIcon} />} />
        }
        text="LightStep"
        isCompact={true}
        href={`https://app.lightstep.com/Atlassian-Main/service-directory/${this.props.id}`}
      />
    );
  }
}
